import { useCallback } from 'react';
import { CircularProgress } from '@mui/material';
import { Button } from '@customink/pigment-react';
import { EmptyFunction } from '~/adapters/typescript/emptyFunction';
import { KnownErrorFields } from '~/adapters/braintree/errorHandler';
import { useHostedFields } from './HostedFieldsContext';
import { sendHostedFieldsDialogEvent } from './sendTrackingEvents';

interface HostedFieldButtonProps {
    closeDialog: EmptyFunction;
    errorFields: KnownErrorFields;
}

export function HostedFieldButtons({ closeDialog, errorFields }: HostedFieldButtonProps) {
    const { submit, saving } = useHostedFields();

    const submitAndSendEvent = useCallback(() => {
        submit();
        sendHostedFieldsDialogEvent('Save');
    }, [submit]);

    const closeDialogAndSendEvent = useCallback(() => {
        closeDialog();
        sendHostedFieldsDialogEvent('Cancel');
    }, [closeDialog]);

    return (
        <>
            <Button variant="secondary" onClick={closeDialogAndSendEvent}>
                Cancel
            </Button>
            <Button onClick={submitAndSendEvent} disabled={!!errorFields.size || saving}>
                {saving ? <CircularProgress color="secondary" size={24} /> : 'Save'}
            </Button>
        </>
    );
}
